<template>
    <div class="animated fadeIn h-100 m-4">
      <CRow>
        <CCol sm="12"><h1>Incidends</h1></CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CCard>
            <CCardHeader><b>Events</b></CCardHeader>
              <CCardBody>
                <CDataTable
                  :hover="true"
                  :striped="true"
                  :items="events"
                  :fields="eventFields"
                  table-filter
                  pagination
                  >
                    <template #time="{item}"><td>{{formatDate(item.time)}}</td></template>
                    <template #status="{item}"><td><CBadge :color="item.status == 'New' ? 'danger' : (item.status == 'Contacted' ? 'warning' : 'secondary')">{{item.status}}</CBadge></td></template>
                    <template #event="{item}"><td>{{item.event == null ? 'N/A' : item.event }}</td></template>
                    <template #actions="{item}"><td><CButton v-if="item.status != 'Resolved'" color="primary" size='sm' shape='pill'>Take action</CButton></td></template>
                  </CDataTable>
              </CCardBody>
          </CCard>
        </CCol>
        <CCol sm="3">
        </CCol>
      </CRow>
  </div>
</template>

<script>
import Vue from 'vue'
import LineChart from './charts/LineChart.js'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import { telemetry } from '@/api'
import store from "@/store"

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)

export default {
  name: 'Building',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      VueSlider,
      LineChart,
      datePicker
  },
  data () {
    return {
      appartments: [],
      center: {lat: 48, lng: 18},
      zoom: 9,
      //poles: [],
      fields: ['device', {key: 'devicename', label: 'Name'}, {key: 'time', label: 'Last event'}, 'event', 'tags', 'tiltx', 'tiltz'],
      events: [],
      eventFields: [{key: 'time', label: 'Time'}, 'status', 'event', 'floor','appartment','actions'],
      device: 'Device',
      deviceName: 'Device',
      temperaturecollection: {
        datasets: [{label: "Temperature", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      batterycollection: {
        datasets: [{label: "Battery", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      inclinationcollection: {
        datasets: [{label: "X axis", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []},
                   {label: "Y axis", backgroundColor: '#40d640', borderColor: '#40d640', type: 'line', lineTension: 0, pointRadius: 0, fill:false, hidden:true, data: []},
                   {label: "Z axis", backgroundColor: '#ff3333', borderColor: '#ff3333', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      timeFormat: 'MM/DD/YYYY HH:mm:ss a',
      tempChartOptions: {
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'series',
                time: {
                  unit: 'hours',
                  //stepSize: 3, // I'm using 3 hour intervals here
                  tooltipFormat: 'DD.MM.YYYY - HH:mm:ss',
                  displayFormats: {
                    hours: 'DD.MM - HH:mm'
                  }
                }
            }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      //markers: [],
      currentMarker: 0,
      paths: [],
      pathsLoaded: [],
      InfoWindowShown: false,
      clustering: false,
      hideLowAcc: true,
      gridSize: 50,
      view: "world",
      dateFrom: this.startOfDay(this.previous2weeks(new Date())),
      dateTo: this.endOfDay(new Date()),
      options: {
        useCurrent: false,
        locale: 'sk'
      },
      sliderOptions: {
        min: 0,
        max: 1,
        interval: 1,
      },
      timestampFormater: v => (this.pathsLoaded.length>0?this.formatDate(this.pathsLoaded[this.pathsLoaded.length - v - 1].time):'')
    }
  },
  computed: {
    path() {
      return this.$router.history.current.fullPath
    },
    currentPole () {
      return this.$store.state.currentDevice
    },
    poles () {
      return this.$store.state.poles
    }
  },
  watch: {
    $route(to, from) {
      this.updateMap()
    },
    currentPole: function(prev, now) {
      /*
      for(var idx=0; idx < this.poles.length; idx++) {
        if(this.poles[idx].device == this.currentPole.device) {
          this.poles[idx].time = this.currentPole.time
          this.poles[idx].event = this.currentPole.event
          this.poles[idx].tiltx = this.currentPole.tiltx
          this.poles[idx].tilty = this.currentPole.tilty
          this.poles[idx].tiltz = this.currentPole.tiltz
          break
        }
      }
      */
      this.redraw(true)
    }
  },
  mounted () {
    this.updateMap()
    this.redraw(false)
    this.events = this.fillEvents()
  },
  methods: {
    fillEvents() {
      var out = []
      var lasttime = (new Date()).getTime() / 1000

      for(var idx=0; idx<30; idx++) {
        lasttime -= Math.floor(Math.random()*216000)
        var event = ''
        switch(Math.round(Math.random()*3)) {
          case 0:
          case 1:
          case 2:
            event = 'Water leak'
            break
          case 3: event = 'Smoke alarm'
            break
        }

        var status = ''
        switch((idx > 1 ? 2 : 0) + Math.round(Math.random()*2)) {
          case 0:
          case 1:
            status = 'New'
            break
          case 2:
            status = 'Contacted'
            break
          case 3:
          case 4:
            status = 'Resolved'
            break
        }

        var floor = Math.round(Math.random()*12) + 1
        out.push({time: lasttime, building: 'Anderstorpsgården', floor: floor, status: status, appartment: ((floor-1)*21) + Math.round(Math.random()*21), event})
      }
      return out
    },
    deviceLock () {
      var that = this
      telemetry.updateDevice({id: this.currentPole.device, config: {tiltx: this.currentPole.tiltx, tilty: this.currentPole.tilty, tiltz: this.currentPole.tiltz}})
        .then(response => {
        this.$toasted.success('Device Locked.')
        that.updateMap()
      }).catch((error) => {
        this.$toasted.error('Unable to save device.')
      })
    },
    previous2weeks (date) {
      date.setDate(date.getDate() - 14)
      return date
    },
    startOfDay (date) {
      date.setHours(0,0,0,0)
      return date
    },
    endOfDay (date) {
      date.setHours(23,59,59,999)
      return date
    },
    redraw (inclination) {
    },
    markerClass (event, temperature) {
      if(temperature < -5) {
        return "fa fa-snowflake-o"
      }
      switch(event) {
        case "open_full":
        case "open_one_tape":
        case "open_one_button":
        case "cap_released":
        case "disarmed":
        case "heartbeat_open":
              return "fa fa-envelope-open-o"
        case "sealed":
        case "sealed_recovered":
        case "armed":
        case "heartbeat_sealed":
              return "fa fa-envelope-o"
        case "stop": return "fa fa-hourglass-o"
        case "tracing": return "fa fa-truck"
        case "start": return "fa fa-arrows"
        case "heartbeat": return "fa fa-heartbeat"
      }
      return "fa fa-gear"
    },
    openDevice(dev, panto) {

    },
    formatDate(date) {
      return (new Date(date*1000)).toLocaleString()
    },
    updateMap() {
    }
  }
}
</script>
